<div class="subscription-info">
    <div class="subscription-info-left">
        <h1>Create your Application</h1>
        <h4>Create application with with just a click of button.</h4>
        <ul>
            <li><i class="fa fa-check success"></i><span class="feature-desc">Unlimited Access</span></li>
            <li><i class="fa fa-check success"></i><span class="feature-desc">Offline Downloads</span></li>
        </ul>
        <h4><span>$</span><span class="bigger-font">59</span><span>/mo</span></h4>
        <div class="timer">
            <div class="hour">{{ timer.split(':')[0] }}</div>
            <div class="divider">:</div>
            <div class="minute">{{ timer.split(':')[1] }}</div>
            <div class="divider">:</div>
            <div class="second">{{ timer.split(':')[2] }}</div>
        </div>
        <button class="claim-now-button" (click)="scrollToSubscriptionContainer()">Claim Now</button>
    </div>
    <div class="subscription-info-right">
        <img class="moving-image" src="../../assets/images/web-development.avif" alt="Image Description">
    </div>
</div>
<div class="subscription-container">
    <h2 class="subscription-heading">Pick Your Perfect Plan</h2>
    <div class="subscription-card basic">
        <div class="card-header-1">
            <h3 class="card-title">BASIC</h3>
            <h5 class="card-subtitle">PER MONTH</h5>
            <h2 class="price">$59</h2>
        </div>
        <div class="card-body">
            <ul class="features">
                <li><i class="fa fa-check success"></i><span class="feature-desc">Unlimited Access</span></li>
                <li><i class="fa fa-times danger"></i><span class="feature-desc">Exclusive Content</span></li>
                <li><i class="fa fa-times danger"></i><span class="feature-desc">Ad-Free Experience</span></li>
                <li><i class="fa fa-times danger"></i><span class="feature-desc">Priority Support</span></li>
                <li><i class="fa fa-check success"></i><span class="feature-desc">Offline Downloads</span></li>
                <li><i class="fa fa-times danger"></i><span class="feature-desc">Member Discounts</span></li>
            </ul>
        </div>
        <div class="card-footer">
            <button class="btn btn-primary-1 order-now-1" (click)="handleOrderNowClick()">
                Order Now <i class="fa fa-angle-right"></i>
            </button>
        </div>
    </div>

    <div class="subscription-card standard">
        <div class="card-header-2">
            <h3 class="card-title">STANDARD</h3>
            <h5 class="card-subtitle">PER MONTH</h5>
            <h2 class="price">$99</h2>
        </div>
        <div class="card-body">
            <ul class="features">
                <li><i class="fa fa-check success"></i><span class="feature-desc">Unlimited Access</span></li>
                <li><i class="fa fa-check success"></i><span class="feature-desc">Exclusive Content</span></li>
                <li><i class="fa fa-times danger"></i><span class="feature-desc">Ad-Free Experience</span></li>
                <li><i class="fa fa-times danger"></i><span class="feature-desc">Priority Support</span></li>
                <li><i class="fa fa-check success"></i><span class="feature-desc">Offline Downloads</span></li>
                <li><i class="fa fa-times danger"></i><span class="feature-desc">Member Discounts</span></li>
            </ul>
        </div>
        <div class="card-footer">
            <button class="btn btn-primary-2 order-now-2">
                Order Now <i class="fa fa-angle-right"></i>
            </button>
        </div>
    </div>

    <div class="subscription-card premium">
        <div class="card-header-3">
            <h3 class="card-title">PREMIUM</h3>
            <h5 class="card-subtitle">PER MONTH</h5>
            <h2 class="price">$149</h2>
        </div>
        <div class="card-body">
            <ul class="features">
                <li><i class="fa fa-check success"></i><span class="feature-desc">Unlimited Access</span></li>
                <li><i class="fa fa-check success"></i><span class="feature-desc">Exclusive Content</span></li>
                <li><i class="fa fa-check success"></i><span class="feature-desc">Ad-Free Experience</span></li>
                <li><i class="fa fa-check success"></i><span class="feature-desc">Priority Support</span></li>
                <li><i class="fa fa-check success"></i><span class="feature-desc">Offline Downloads</span></li>
                <li><i class="fa fa-check success"></i><span class="feature-desc">Member Discounts</span></li>
            </ul>
        </div>
        <div class="card-footer">
            <button class="btn btn-primary-3 order-now-3">
                Order Now <i class="fa fa-angle-right"></i>
            </button>
        </div>
    </div>
</div>
<button id="goToTopBtn" (click)="goToTop()" class="go-to-top-button"><i class="fa-solid fa-arrow-up"></i></button>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="pacman" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>